import { Button, Input, InputRef, Modal,Space,Table } from 'antd'
import React,{useEffect} from 'react'
import { formatNumberWithCommas } from '../../utilities/CommonHelper';
import { ColumnType, FilterConfirmProps } from 'antd/es/table/interface';
import Highlighter from 'react-highlight-words';
import { SearchOutlined } from '@ant-design/icons';

interface DataType {
  workOrderId: string;
  parentId: string;
  tcvAmount: number;
  tcvAmountUsd: number;
  revenueRecognizedUsd: number;
  oboUsd: number;
}

type DataIndex = keyof DataType;

const WorkOrderRevenueModal = (props:any) => {
  const [workorderLevelList, setWorkorderLevelList] = React.useState([]);
  const [searchText, setSearchText] = React.useState('');
  const [searchedColumn, setSearchedColumn] = React.useState('');
  const searchInput = React.useRef<InputRef>(null);

  useEffect(() => {
      if(props.isModalOpen){
        setWorkorderLevelList(props.selectedSOW.workOrderDetails);
      }else{
        setWorkorderLevelList([]);

      }
  }, [props.isModalOpen])


      const handleSearch = (
        selectedKeys: string[],
        confirm: (param?: FilterConfirmProps) => void,
        dataIndex: DataIndex,
      ) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
      };
    
      const handleReset = (clearFilters: () => void) => {
        clearFilters();
        setSearchText('');
      };
      const getColumnSearchProps = (dataIndex: DataIndex): ColumnType<any> => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
          <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
            <Input
              ref={searchInput}
              placeholder={`Search ${dataIndex}`}
              value={selectedKeys[0]}
              onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
              onPressEnter={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
              style={{ marginBottom: 8, display: 'block' }}
            />
            <Space>
              <Button
                type="primary"
                onClick={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                icon={<SearchOutlined />}
                size="small"
                style={{ width: 90 }}
              >
                Search
              </Button>
              <Button
                onClick={() => {
                  setSelectedKeys([]);
                  handleSearch([], confirm, dataIndex);
                }}
                size="small"
                style={{ width: 90 }}
              >
                Reset
              </Button>
            </Space>
          </div>
        ),
        filterIcon: (filtered: boolean) => (
          <SearchOutlined style={{ color: filtered ? '#1677ff' : undefined }} />
        ),
        onFilter: (value, record) =>
        record[dataIndex] && record[dataIndex]
            .toString()
            .toLowerCase()
            .includes((value as string).toLowerCase()),
        onFilterDropdownOpenChange: (visible) => {
          if (visible) {
            setTimeout(() => searchInput.current?.select(), 100);
          }
        },
        render: (text) =>
          searchedColumn === dataIndex ? (
            <Highlighter
              highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
              searchWords={[searchText]}
              autoEscape
              textToHighlight={text ? text.toString() : ''}
            />
          ) : (
            text
          ),
      });

  return (
    <Modal
    title="Work Order Revenue"
    open={props.isModalOpen}
    onCancel={()=>props.onCancel()}
    footer={null}
    width={1000}
    styles={{
      content: {
        borderRadius: '0',
        borderTop: '4px solid #1677ff',
        font: 'normal normal normal 14px/20px Nunito Sans',
        zIndex: 9998,
      },
    }}
    >
    <>
                  <div>

                    <p>
                      <b>SOW Id :</b> {props.selectedSOW?.sowId}
                    </p>
                    </div>
                    <Table
                    dataSource={workorderLevelList}
                    scroll={{ x: 'max-content',y: 300}}
                    className='table-style'
                    columns={[
                      {
                        title: 'Work Order ID',
                        dataIndex: 'workOrderId',
                        key: 'workOrderId',
                        width: 150,
                        ...getColumnSearchProps('workOrderId'),
                      },
                      {
                        title: 'Parent Id',
                        dataIndex: 'parentId',
                        key: 'parentId',
                        width: 150,
                        ...getColumnSearchProps('parentId'),
                      },
                      {
                        title: 'Total Contract Value',
                        dataIndex: 'tcvAmount',
                        key: 'tcvAmount',
                        width: 150,
                        render: (text: any, record: any) => {
                          return(
                            <span>{`${formatNumberWithCommas(text)}`}</span>
                          )
                        }
                      },
                      {
                        title: 'Total Contract Value (USD)',
                        dataIndex: 'tcvAmountUsd',
                        key: 'tcvAmountUsd',
                        width: 150,
                        render: (text: any, record: any) => {
                          return(
                            <span>{`$${formatNumberWithCommas(text)}`}</span>
                          )
                        }
                      },
                      {
                        title: 'Revenue Recognised',
                        dataIndex: 'revenueRecognizedUsd',
                        key: 'revenueRecognizedUsd',
                        width: 150,
                        render: (text: any, record: any) => {
                          return(
                            <span>{`$${formatNumberWithCommas(text)}`}</span>
                          )
                        }
                      },
                      {
                        title: 'OBO Value',
                        dataIndex: 'oboUsd',
                        key: 'oboUsd',
                        width: 150,
                        render: (text: any, record: any) => {
                          return(
                            <span>{`$${formatNumberWithCommas(text)}`}</span>
                          )
                        }
                      }

                    ]}
                    />
                </>

  </Modal>
  )
}
export default WorkOrderRevenueModal;
